export const MARKET_NOT_NAME_IN_OUTCOME = [
  "128",
  "134",
  "145",
  "146",
  "147",
  "148",
  "149",
  "150",
  "163",
];

export const MARKET_ASIAN_HANDICAP = [
    '342'
]
